import type { Plugin } from 'vue';
import { container } from '@shared/common/dependency-injection/domain/container';
import type { TrackingService } from '@shared/common/tracking/domain/service/tracking.service';
import { TrackingDependencyTypes } from '@shared/common/tracking/tracking.dependency-types';
import { noCaptureDirective } from '@shared/common/tracking/application/directive/no-capture.directive';
import { captureInputNameDirective } from '@shared/common/tracking/application/directive/capture-input-name.directive';
import { captureButtonNameDirective } from '@shared/common/tracking/application/directive/capture-button-name.directive';

export type TrackingVuePluginOptions = {
  enableTracking?: boolean;
};

export const TrackingVuePlugin: Plugin = {
  install(app, options: TrackingVuePluginOptions = {}) {
    app.directive('no-capture', noCaptureDirective);
    app.directive('capture-input-name', captureInputNameDirective);
    app.directive('capture-button-name', captureButtonNameDirective);

    if (options.enableTracking === false) {
      return;
    }

    const trackingService = container.get<TrackingService>(TrackingDependencyTypes.TrackingService);
    trackingService.initialize();

    const errorHandler = app.config.errorHandler;
    app.config.errorHandler = (err, instance, info) => {
      trackingService.reportException(err);
      errorHandler?.(err, instance, info);
    };
  },
};
